module.exports = __webpack_public_path__ + "static/media/124.686b57c7.png";